import { FC } from 'react';
import classNames from 'classnames';
import { ButtonOutline, Icon } from '@lambdacurry/component-library';
import { useFilters } from './Filters.helpers';
import { Filter, FilterOption } from './Filters.types';

export interface FiltersOptionProps extends FilterOption {}

export const FiltersOption: FC<FiltersOptionProps> = ({ value, name, label, icon }) => {
  const { state, actions } = useFilters();
  const { filters } = state;
  const { toggleFilter } = actions;

  const isActive = filters.find(filter => filter.name === name && filter.value === value);

  const handleFilterClick = (filter: Filter) => toggleFilter(filter);

  return (
    <li key={value} className="filters__option flex-shrink-0">
      {/**
       * These styles have a lot of overlap with the SelectionButton component.
       * Perhaps we should find a way to refactor and bring them together.
       */}
      <ButtonOutline
        className={classNames(
          `'filters__option__button`,
          `pr-3 pl-6 h-12 text-sm`,
          `hover:!bg-brand-green-50 hover:!border-brand-green-300`,
          {
            ['!bg-white !border-brand-cool-gray-50 !font-normal']: !isActive,
            ['!bg-brand-green-50 !border-brand-green-300 !font-bold']: isActive
          }
        )}
        onClick={() => handleFilterClick({ name, value })}
        icon={icon ? <Icon name={icon} /> : ''}
        data-cy="filters-option"
      >
        {label}
      </ButtonOutline>
    </li>
  );
};
